import ErrorPage from './Index'

const ErrorPage500 = () => {
  return (
    <ErrorPage
      code='500'
      errorText={
        <div>
          Looks like something went wrong.<br />
          We are working on it.
        </div>
      }
    />
  )
}

export default ErrorPage500
